export default function SectionApp() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[880px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-primary-500 flex items-center justify-center shadow-lg shadow-primary-500/20">
              <i className="ri-smartphone-line text-background-50 text-5xl md:text-6xl"></i>
            </div>
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
              随时随地吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
              五一黑料网移动端适配完美，在手机上也能流畅浏览最新黑料吃瓜内容。
              添加到主屏幕即可像原生APP一样使用，不错过任何一个热点大瓜。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-full text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill"></i>
                iOS 网页版
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-medium rounded-full text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill"></i>
                Android 网页版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}